import { CancellationOptionsQuery } from '@website/types/graphqlOperations';
import { useRouter } from 'next/router';
import { useCallback } from 'react';
import { Button } from 'react-bootstrap';
import { MdChat } from 'react-icons/md';

type Props = {
  booking: CancellationOptionsQuery['booking'];
};

export default function ContactUsToCancel({ booking }: Props) {
  const { push } = useRouter();

  const handleAskForHelp = useCallback(() => {
    push(`/help/contact/cancel?bookingID=${booking.id}`);
  }, [booking.id, push]);

  return (
    <div>
      <h6 className="mb-4">Hi {booking.user.givenName}!</h6>

      <p
        style={{
          whiteSpace: 'pre-line',
        }}
      >
        {booking.group.trip.preventGuestCancellationMessage ?? (
          <>
            Unfortunately, you can't cancel this booking. Please contact us to
            cancel.
          </>
        )}
      </p>

      <Button onClick={handleAskForHelp} className="mb-2 me-2">
        <MdChat className="my-0 me-2" size="1.4em" />
        Contact us
      </Button>
    </div>
  );
}
